module.exports = __webpack_public_path__ + "static/media/edit-blue.30ff7ef8.svg";